import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import OnePlatform from "./OnePlatform";
import OneStep from "./OneStep";
import Community from "./community/Community";
import BuildingTrust from "./BuildingTrust";
import Footer from "./Footer";

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <OnePlatform />
      <OneStep />
      <Community />
      <BuildingTrust />
      <Footer />
    </>
  );
};

export default Home;
